// @ts-expect-error - no types available for xxhashjs
import XXH from 'xxhashjs';

/**
 * Generates a deterministic, fixed-length association key for a product configuration.
 * Uses xxHash (non-cryptographic) for speed and collision safety.
 *
 * @param {string} mainSku - The SKU/Key of the main product
 * @param {string[]} addonSkus - Array of SKUs/Keys for selected add-ons
 * @param {string[]} optionSkus - Array of SKUs/Keys/Names for selected options
 * @param {string} priceRate - The selected price rate (e.g. 'standard-rate')
 * @returns {string} - A key in the format "bundle_<12-char-hash>"
 */
export const generateAssociationKey = (mainSku: string, addonSkus: string[] = [], optionSkus: string[] = [], priceRate: string = ''): string => {
    // 1. NORMALIZE: Sort arrays to ensure order-independence
    const configObject = {
        m: mainSku,
        a: [...addonSkus].filter(Boolean).sort(),
        o: [...optionSkus].filter(Boolean).sort(),
        p: priceRate
    };

    // 2. STRINGIFY: Create a unique string representation
    const jsonString = JSON.stringify(configObject);

    // 3. HASH: Generate hash using xxHash (64-bit)
    // Seed is 0xCAFEBABE (arbitrary constant)
    const hash = XXH.h64(jsonString, 0xCAFEBABE).toString(16);

    // Take first 12 chars (enough for uniqueness in this context)
    const shortHash = hash.substring(0, 12);

    return shortHash;
};
